import { AbstractDataProviderV2 } from 'components/system/data-provider';
import { A9Service } from 'components/system/angular/A9Service';
import { RsCustomerSocial } from 'common/customers/services/types/RsCustomerSocial';
import { CustomerSocialAdd } from 'common/customers/services/types/CustomerSocialAdd';
import { RsCustomerSocialInfo } from 'common/customers/services/types/RsCustomerSocialInfo';
import { CustomerSocialUpdate } from 'common/customers/services/types/CustomerSocialUpdate';

@A9Service('customerSocialDataProvider')
export class CustomerSocialDataProvider extends AbstractDataProviderV2<
    RsCustomerSocial,
    RsCustomerSocialInfo,
    CustomerSocialAdd,
    CustomerSocialUpdate
> {
    constructor() {
        super();
        this.setApiUrl('middle://rs/customers/{customerId}/socials');
    }

    public patch() {
        return Promise.reject('Method `patch` is not available');
    }
}
